(function () {
  const MIN_SCROLL_PERCENT = 30;
  const MAX_SCROLL_PERCENT = 60;

  // Move the bar to be a direct child of <body>. Left in its original
  // position, position: fixed would pin it relative to the nearest ancestor
  // that creates a containing block (transform/filter/perspective/etc.) —
  // e.g. the product info wrapper gets transform: translateY(...) from the
  // "reveal on scroll" animation classes — instead of the real viewport.
  const bars = Array.from(document.querySelectorAll('.sticky-add-to-cart'));
  bars.forEach((bar) => document.body.appendChild(bar));

  if (bars.length) {
    let ticking = false;

    function updateVisibility() {
      ticking = false;
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = scrollableHeight > 0 ? (window.scrollY / scrollableHeight) * 100 : 0;
      const withinRange = scrollPercent >= MIN_SCROLL_PERCENT && scrollPercent <= MAX_SCROLL_PERCENT;

      bars.forEach((bar) => bar.classList.toggle('is-visible', withinRange));
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateVisibility);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateVisibility();
  }

  document.querySelectorAll('[data-sticky-add-to-cart-trigger]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.dataset.target);
      if (!target || target.disabled) return;
      target.click();
    });
  });
})();
